module.exports = __webpack_public_path__ + "media/images/menu_izq/prestador-41cc2c742ac3dbc3f00c3b16f9c5eae9.svg";